<template>
    <div class="card-container">
        <loader
            v-if="loading"
        />
        <div class="lam-list-filters uk-margin-bottom">
            <ul slot="filters" class="uk-tab lam-filters">
                <li :class="{'uk-active': !studio_id}">
                    <a href @click.prevent="studio_id = 0">All</a>
                </li>
                <li
                    v-for="studio in studios"
                    :key="studio.id"
                    :class="{'uk-active': studio_id === studio.id}"
                >
                    <a href @click.prevent="studio_id = studio.id">{{ studio.name }}</a>
                </li>
            </ul>
        </div>
        <table>
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th
                        v-for="week in weeks"
                        :key="week.id"
                        :colspan="week.colspan"
                    >
                        {{ week.name }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="initial in initials"
                    :key="initial"
                >
                    <th>{{ initial }}</th>
                    <td
                        v-for="date in dates"
                        :key="date.dayOfYear()"
                        :title="title_for_cell(initial, date)"
                        :class="class_for_cell(initial, date)"
                    >
                        <!--
                        <span v-if="date.isSame($moment(), 'day')">&bull;</span>
                        <span v-else>&nbsp;</span>
                        //-->
                        &nbsp;
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from "vuex"

import profile_utilities from "../../mixins/ProfileUtilities"
import dashboard_card from "./dashboard_card"

import Loader from "../../ui/Loader"

// gray for holidays, blue for professional development time, green for time off
export default {
    mixins: [profile_utilities, dashboard_card],
    components: {
        Loader
    },
    mounted () {
        let date = this.$moment().startOf("week").add(1, "day")
        this.dates_delta = Math.max(0, this.$moment().diff(date, "days") - 1)
        const max_date = this.$moment().add(6, "months")
        while(date.isSameOrBefore(max_date)) {
            const day_of_week = date.day()
            if(!!day_of_week && (day_of_week !== 6)) {
                this.dates.push(date)

                const week_id = `W${date.week()}`
                if(!this.weeks[week_id]) this.weeks[week_id] = { id: week_id, name: date.format("MMM-D"), colspan: 1 }
                else this.weeks[week_id].colspan++
            }

            date = date.clone().add(1, "day")
        }

        this.holidays.forEach(holiday => {
            let date = this.$moment(holiday.starts_at)
            const max_date = this.$moment(holiday.ends_at)
            while(date.isSameOrBefore(max_date)) {
                this.holiday_dates.push(date.format("YYYY-MM-DD"))
                date = date.clone().add(1, "day")
            }
        })

        this.load_data()
    },
    watch: {
        profile_id: "load_data",
        $route: "load_data"
    },
    methods: {
        load_data () {
            if(this.profile_id) {
                this.loading = true
                this.$store.dispatch("DASHBOARD_DATA", { entity: this.card.entity, data_id: this.card.id }).then(data => {
                    this.data = data
                    this.$nextTick(() => {
                        this.$el.scroll((this.dates_delta * 22), 0)
                    })
                }).catch(error => {
                    console.error(error)
                }).then(() => {
                    this.loading = false
                })
            }
        },
        title_for_cell (initial, date) {
            const date_as_string = date.format("YYYY-MM-DD")
            let period = null
            if(Object.keys(this.data[initial].development).indexOf(date_as_string) >= 0) period = this.data[initial].development[date_as_string]
            else if(Object.keys(this.data[initial].outage).indexOf(date_as_string) >= 0) period = this.data[initial].outage[date_as_string]
            else if(Object.keys(this.data[initial].off).indexOf(date_as_string) >= 0) period = this.data[initial].off[date_as_string]
            if(period) return `${initial}: ${period}`
            return null
        },
        class_for_cell (initial, date) {
            const date_as_string = date.format("YYYY-MM-DD")
            const classes = { "end-of-week": (date.day() === 5), "start-of-month": (date.date() === 1) }
            if(this.holiday_dates.indexOf(date_as_string) >= 0) classes.holiday = true
            else if(Object.keys(this.data[initial].development).indexOf(date_as_string) >= 0) classes.development = true
            else if(Object.keys(this.data[initial].outage).indexOf(date_as_string) >= 0) classes.outage = true
            else if(Object.keys(this.data[initial].off).indexOf(date_as_string) >= 0) classes.off = true
            return classes
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        ...mapState(["holidays"]),
        initials () {
            const initials = Object.keys(this.data)
            if(!this.studio_id) return initials
            return initials.filter(initial => {
                return this.data[initial].studio_id === this.studio_id
            })
        },
        studios () {
            return this.entity_records("studio")
        }
    },
    data () {
        return {
            studio_id: 0,
            dates: [],
            dates_delta: 0,
            weeks: {},
            holiday_dates: [],
            data: {}
            /*
            {
                JLC: {
                    off: ["2026-03-30", "2026-04-04", "2026-04-05", "2026-04-06", "2026-04-07", "2026-04-08"],
                    development: ["2026-03-29"]
                }
            }
            */
        }
    }
}
</script>

<style lang="less">
@import "@/assets/less/variables";

#user-out-of-office {
    height: auto;

    .uk-panel {
        display: flex;
        flex-direction: column;
        overflow: hidden;

        & > .uk-grid {
            flex: 0 0 auto;
        }
        & > .lam-card-body {
            flex: 1 1 100%;
            overflow: hidden;
            .card-container {
                overflow: auto;
                height: 100%;

                .lam-list-filters {
                    position: sticky;
                    top: 0;
                    left: 0;
                }
            }
        }
    }

    table {
        @color-holiday: #999999;
        @color-off: #93c47d;
        @color-development: #6fa8dc;
        @color-outage: @global-lam-sunset;

        border-collapse: collapse;

        th {
            position: sticky;
            top: 0;
            padding: 0 10px;
            background-color: white;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        thead th {
            padding-bottom: 10px;
            border-bottom: 1px solid @global-lam-daylight;
        }
        tbody th,
        tbody td.end-of-week {
            border-right: 1px solid @global-lam-daylight;
        }
        tbody td.start-of-month {
            border-left: 1px solid @global-lam-sunrise;
        }
        tbody th {
            top: 31px;
            left: 0;
            border-bottom: 1px solid @global-lam-gray;
        }
        td {
            text-align: center;
            color: @global-lam-sunset;
            min-width: 10px;
            width: 10px;
            max-width: 10px;
            border-bottom: 1px solid @global-lam-gray;

            &.holiday {
                background-color: @color-holiday;
                &:hover {
                    background-color: darken(@color-holiday, 25%)
                }
            }
            &.off {
                background-color: @color-off;
                &:hover {
                    background-color: darken(@color-off, 25%)
                }
            }
            &.development {
                background-color: @color-development;
                &:hover {
                    background-color: darken(@color-development, 25%)
                }
            }
            &.outage {
                background-color: @color-outage;
                &:hover {
                    background-color: darken(@color-outage, 25%)
                }
            }
        }
    }
}
</style>
